<template>
  <card-modal-component
    :show="showModal"
    @deactivate="toggleModal()"
    transition="fade"
    ref="modal"
    @handleOk="combineInvoice($event)"
    @handleCancel="toggleModal()"
    :title="`Combine invoice`">
    <div slot="card-content">
      <translate>Do you want to combine this invoice with another invoice?</translate>
      <select-component
        v-if="selectInvoiceField"
        :field="selectInvoiceField">
      </select-component>
    </div>
  </card-modal-component>
</template>
<script>
  import Vue from 'vue'
  import { mapState, mapActions } from 'vuex'
  import CardModalComponent from '@/components/layout/modal/CardModalComponent'
  import SelectComponent from '@/components/layout/utility/form/SelectComponent'
  import { errorHandler } from '@/mixins/mixins'
  import { InvoiceState } from '@/classes/case/Invoice'
  import InvoiceCustomer from '@/classes/case/InvoiceCustomer'

  export default {
    name: 'bulk-invoice-modal-component',
    mixins: [errorHandler],
    components: {
      CardModalComponent,
      SelectComponent
    },
    data () {
      return {
        showModal: false,
        selectInvoiceField: null
      }
    },
    props: {
      caseId: {
        required: true
      },
      invoiceCustomer: {
        type: InvoiceCustomer,
        required: true
      }
    },
    computed: {
      ...mapState({
        invoices: state => state.invoiceModule.invoices
      })
    },
    methods: {
      ...mapActions([
        'getInvoices'
      ]),
      getDraftInvoices () {
        let request = {
          state: InvoiceState.DRAFT,
          invoice_customer: this.invoiceCustomer.id
        }
        this.getInvoices(request).then(() => {
          if (this.invoices.length) {
            this.toggleModal()
            this.setSelectInvoiceField(this.invoices)
          }
        }).catch((err) => {
          this.handleError(err)
        })
      },
      setSelectInvoiceField (invoices) {
        let options = invoices.map(invoice => {
          return {
            value: invoice.id,
            display: `${invoice.invoiceNumber} - ${invoice.marking}`
          }
        })
        this.selectInvoiceField = {
          id: 'select-invoice',
          value: options[0].value,
          eventBus: new Vue(),
          properties: {
            options: options
          },
          validation: {
            is_required: true,
            message: 'You need to select an invoice.'
          }
        }
      },
      combineInvoice (btn) {
        btn.enable()
        this.selectInvoiceField.eventBus.$emit('validate')
        if (this.selectInvoiceField.validation.is_valid) {
          this.toggleModal()
          this.$nextTick(() => {
            this.$router.push({
              name: 'InvoiceEditView',
              params: { invoiceId: this.selectInvoiceField.value },
              query: { connectCaseId: this.caseId }
            })
          })
        }
      },
      toggleModal () {
        this.showModal = !this.showModal
      }
    },
    created () {
      if (this.invoiceCustomer.bulkInvoice) {
        this.getDraftInvoices(this.invoiceCustomer.id)
      }
    }
  }
</script>
